import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function filesLengthValidator(allowedLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value?.length === 'number' && control.value.length <= allowedLength) {
      return null;
    }

    return { fileLengthError: true };
  };
}

export function filesWeightValidator(maxSizeInMB: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fileList = control.value as FileList;

    if (!fileList?.length) {
      return null;
    }

    const maxSizeBytes = maxSizeInMB * 1024 * 1024;

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);

      if (file.size > maxSizeBytes) {
        return { filesWeightError: true };
      }
    }

    return null;
  };
}

export function filesRequired(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fileList = control.value as FileList;

    if (fileList && fileList?.length === 0) {
      return { filesRequired: true };
    }

    return null;
  };
}
